export const marqueeItems = [
  '【新瓜速递】主播「抽卡式直播」一晚开百场，弹幕直接吵成菜市场',
  '【前线爆料】某平台新机发布会刚结束，「退货指南」已经连夜写完',
  '【最新瓜】选秀复活赛灯牌把场馆顶棚照成银河，前排都看不清舞台',
  '【实时更新】昨晚补时绝杀那脚，解说破音片段半小时内被转了三万次',
  '【前线爆料】科技区头部博主连夜改口，评论区已开启站队模式',
  '【新瓜速递】「吃瓜不睡觉」话题凌晨三点冲到实时榜第二，前排越夜越精神',
];

export const heroStats = [
  { label: '今日新瓜', value: '1,286', suffix: '个' },
  { label: '在线吃瓜', value: '3.6', suffix: '万人' },
  { label: '前排热评', value: '9.8', suffix: '万条' },
];

export const navSections = [
  { label: '新瓜速递', icon: 'ri-flashlight-fill' },
  { label: '前线爆料', icon: 'ri-radar-fill' },
  { label: '实锤专区', icon: 'ri-folder-2-fill' },
  { label: '前排评论', icon: 'ri-chat-3-fill' },
  { label: '吃瓜圈子', icon: 'ri-fire-fill' },
];

export const featuredMelons = [
  {
    id: 'g1',
    tag: '爆',
    tagTone: 'primary',
    cat: '直播圈',
    catIcon: 'ri-live-line',
    title: '「抽卡式直播」突然爆火，主播一晚上连开百场',
    summary: '抽一张卡换一次整活，节目效果拉满也拉爆了血压。前后过程、主播回放和网友录屏都给你拢齐了，事件刚发酵就能看全。',
    heat: 128.6,
    comments: 6842,
    time: '刚刚',
    author: '搬瓜员·小瓜',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20live%20streaming%20desk%20scene%20with%20a%20glowing%20screen%2C%20floating%20chat%20comment%20bubbles%20and%20reaction%20icons%20spilling%20out%2C%20a%20deck%20of%20colorful%20cards%20scattered%20around%2C%20warm%20cream%20background%2C%20high%20contrast%20watermelon%20red%20and%20fresh%20green%20editorial%20palette%2C%20bold%20clean%20vector%20style%2C%20no%20text&width=1200&height=820&seq=feed-card-01&orientation=landscape',
  },
  {
    id: 'g2',
    tag: '新',
    tagTone: 'accent',
    cat: '科技圈',
    catIcon: 'ri-smartphone-line',
    title: '新机发布会刚开完，「退货指南」已连夜出完',
    summary: '参数党、颜值党、续航党各说各话，前后晒单和拆机截图都已归档。按时间线补全，不用东翻西找，最新瓜跟进不掉队。',
    heat: 96.4,
    comments: 4210,
    time: '8 分钟前',
    author: '搬瓜员·陈皮',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20flagship%20smartphone%20launch%20stage%20scene%20with%20spotlights%20and%20glowing%20spec%20numbers%20floating%20in%20the%20air%2C%20a%20unboxing%20box%20with%20phone%20opened%20beside%20the%20screen%2C%20warm%20cream%20background%2C%20watermelon%20red%20and%20fresh%20green%20editorial%20palette%2C%20bold%20clean%20vector%20style%2C%20no%20text&width=1200&height=820&seq=feed-card-02&orientation=landscape',
  },
  {
    id: 'g3',
    tag: '热',
    tagTone: 'primary',
    cat: '饭圈',
    catIcon: 'ri-mic-line',
    title: '选秀复活赛应援灯牌，把场馆顶棚照成银河',
    summary: '灯牌海、应援色和翻车现场全在现场直拍里。前后应援明细和舞台侧拍都已汇总，实时更新，越夜越有瓜。',
    heat: 82.1,
    comments: 3166,
    time: '22 分钟前',
    author: '搬瓜员·柠檬',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20stadium%20concert%20scene%20filled%20with%20rows%20of%20glowing%20fan%20light%20sticks%20and%20heart%20shaped%20banner%20lights%20lighting%20up%20the%20dark%20auditorium%2C%20a%20distant%20spotlit%20stage%2C%20warm%20cream%20background%2C%20high%20contrast%20watermelon%20red%20and%20fresh%20green%20editorial%20palette%2C%20bold%20clean%20vector%20style%2C%20no%20text&width=1200&height=820&seq=feed-card-03&orientation=landscape',
  },
  {
    id: 'g4',
    tag: '新',
    tagTone: 'accent',
    cat: '体育',
    catIcon: 'ri-flag-line',
    title: '补时读秒绝杀，解说破音片段被转了三万次',
    summary: '从判罚争议到庆祝名场面，前后解说切片和现场机位都已归档。按时间线给你排好，前排补课不吃亏。',
    heat: 67.9,
    comments: 2988,
    time: '41 分钟前',
    author: '搬瓜员·二狗',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20football%20stadium%20final%20minute%20goal%20scene%20with%20a%20confetti%20burst%20and%20goal%20net%20rippling%2C%20a%20scoreboard%20showing%20added%20time%2C%20roaring%20crowd%20silhouettes%20waving%20scarves%2C%20warm%20cream%20background%2C%20watermelon%20red%20and%20fresh%20green%20editorial%20palette%2C%20bold%20clean%20vector%20style%2C%20no%20text&width=1200&height=820&seq=feed-card-04&orientation=landscape',
  },
];

export const rankingTopics = [
  { title: '直播间「抽卡整活」算不算挂羊头卖狗肉？', cat: '直播圈', heat: 128.6, delta: 'up', tag: '爆' },
  { title: '新机首发当天掉价，首发党为什么还冲？', cat: '科技圈', heat: 96.4, delta: 'up', tag: '热' },
  { title: '复活赛现场灯牌与保安的第九次拉锯', cat: '饭圈', heat: 82.1, delta: 'up', tag: '热' },
  { title: '补时绝杀判罚到底有没有问题？', cat: '体育', heat: 67.9, delta: 'flat', tag: '议' },
  { title: '「吃瓜不睡觉」夜聊楼，前排谁还在线', cat: '闲聊', heat: 51.3, delta: 'up', tag: '楼' },
  { title: '大主播团队又解散，这次是因为分账', cat: '直播圈', heat: 44.8, delta: 'down', tag: '深' },
  { title: '年度盘点提前启动，评论区已在压宝', cat: '饭圈', heat: 38.2, delta: 'flat', tag: '期' },
];

export const evidenceThreads = [
  {
    id: 'e1',
    cat: '直播圈 · 抽卡直播',
    title: '「开一场删一话」后台对话流出',
    desc: '搬瓜员整理了前后两边的对线记录，红脸归红脸，截图一张不少。',
    lines: [
      { side: 'A', name: '场控·老K', text: '节奏起太快了，下一场要不要把卡池压一压？' },
      { side: 'B', name: '运营·阿May', text: '压不住，弹幕全在喊开满。先把回放挂上，别又给人说录播。' },
      { side: 'A', name: '场控·老K', text: '行，那就实况到底，谁再刷“内定”我截图了。' },
    ],
    meta: '3 段 · 前后各执一词',
  },
  {
    id: 'e2',
    cat: '科技圈 · 首发',
    title: '渠道内部群的「调价风声」截图',
    desc: '一条内部消息能引起多大震动？这里有截图也有时间戳对照。',
    lines: [
      { side: 'A', name: '渠道·大熊', text: '听说后天渠道价会有动作，先别压太多货。' },
      { side: 'B', name: '门店·小鹿', text: '那我今早那台现货岂不是首发即亏……上家这话准吗？' },
      { side: 'A', name: '渠道·大熊', text: '来源我不点名，就四个字：内部确凿。你看着办。' },
    ],
    meta: '2 张 · 时间戳已对齐',
  },
  {
    id: 'e3',
    cat: '饭圈 · 灯牌事件',
    title: '应援群投票记录：保灯牌还是保演出',
    desc: '群聊投票与解散公告先后流出，各执一词的部分已用红框标出。',
    lines: [
      { side: 'A', name: '群管·糖糖', text: '主办说再亮就扣演出时长，投票吧：收灯还是继续？' },
      { side: 'B', name: '粉丝·阿泽', text: '必须继续，顶棚都亮了现在撤等于认怂。' },
      { side: 'A', name: '群管·糖糖', text: '那就开投，结果十分钟后我发群公告。' },
    ],
    meta: '1 份 · 投票分布见截图',
  },
];

export const hotComments = [
  {
    id: 'c1',
    name: '前排选手·小林',
    floor: '1 楼',
    time: '刚刚',
    text: '蹲到了蹲到了，这瓜我刚洗完澡就发酵了，前排占个座慢慢吃。',
    likes: 3260,
    replies: 214,
  },
  {
    id: 'c2',
    name: '吃瓜十级学者',
    floor: '7 楼',
    time: '2 分钟前',
    text: '看了三遍回放才看懂那脚，说实话这波谁都不冤，就看谁能拿出实锤。',
    likes: 2841,
    replies: 98,
  },
  {
    id: 'c3',
    name: '夜猫子·不加糖',
    floor: '13 楼',
    time: '5 分钟前',
    text: '凌晨三点还在更，这个实时更新的劲儿我服。已经拉好小板凳了，坐等反转。',
    likes: 1998,
    replies: 76,
  },
  {
    id: 'c4',
    name: '路过的马甲',
    floor: '21 楼',
    time: '8 分钟前',
    text: '别急着下结论，前排那句「再等五分钟」我记着呢。聊天记录和截图都收好了，蹲后续。',
    likes: 1654,
    replies: 41,
  },
];

export const communitySections = [
  { key: 'live', name: '直播圈', icon: 'ri-live-fill', color: 'bg-primary-100 text-primary-700', online: '1.2 万人在线', desc: '整活与翻车现场一网打尽' },
  { key: 'tech', name: '科技圈', icon: 'ri-cpu-fill', color: 'bg-accent-100 text-accent-700', online: '8600 人在线', desc: '参数、爆料与首发党战场' },
  { key: 'fan', name: '饭圈', icon: 'ri-heart-fill', color: 'bg-primary-100 text-primary-700', online: '9800 人在线', desc: '应援、撕番与每日一吵' },
  { key: 'sport', name: '体育', icon: 'ri-trophy-fill', color: 'bg-accent-100 text-accent-700', online: '5200 人在线', desc: '判罚争议与名场面复盘' },
  { key: 'chat', name: '闲聊夜聊', icon: 'ri-moon-fill', color: 'bg-secondary-100 text-secondary-700', online: '6600 人在线', desc: '吃瓜不睡觉，前排唠到天亮' },
  { key: 'stock', name: '剧综盘点', icon: 'ri-clapperboard-fill', color: 'bg-secondary-100 text-secondary-700', online: '7300 人在线', desc: '烂尾预警与年度压宝' },
];